export {
  VideoCapturePermissions,
  type VideoCapturePermissionsProps,
} from './VideoCapturePermissions';
